import React, { useEffect, useRef, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<{}>}
 */
export const Grid = (props) => {
    const gridRef = useRef(null);

    const [showGridLines, setShowGridLines] = useState(false);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (event.ctrlKey && event.shiftKey && (Number(event.key) === 4) || event.key === '$' ) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown', toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    useEffect(() => {
        if (gridRef.current) {
            if (showGridLines) {
                gridRef.current.showPopover();
            } else {
                gridRef.current.hidePopover();
            }
        }
    }, [showGridLines]);

    return (
        <div
            className='fixed inset-0 h-full w-full m-0 p-0 bg-transparent pointer-events-none'
            popover='manual'
            ref={gridRef}>
            <div className={`${props.isParentHomePage ? 'home-page' : ''} layout-container h-screen`}>
                <div className='grid grid-cols-12 h-full gap-16 sm:gap-16'>
                    {Array(12).fill(null).map((_, i) => {
                        const classes = [];
                        return (
                            <div
                                className={classes.join(' ')}
                                key={i}
                                style={{ backgroundColor: '#e0e0e050' }} />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Grid;
